module.exports = __webpack_public_path__ + "static/media/award-badges-row.14884c8a.png";